import {giftUnits,giftProperties,giftReconciliation} from './cc-gift-core.js?v=20261001-3';
const base=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
const fees={1900:57616004120949,3900:57616004153717};
let busy=false;
async function request(path,body){
 const response=await fetch(base+path,{cache:'no-store',...(body?{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}:{})});
 const data=await response.json();
 if(!response.ok)throw Error(data.description||'Nie udało się zapisać pakowania. Spróbuj ponownie.');
 return data;
}
async function reconcile(){
 let cart=await request('cart.js');
 for (const line of cart.items.filter(i=>i.properties?._cc_gift_group && !i.properties?._cc_gift_role)) {
  const properties=giftProperties(line,giftUnits(line),line.properties._cc_gift_group);
  if(JSON.stringify(properties)!==JSON.stringify(line.properties)) {
   cart=await request('cart/change.js',{id:line.key,quantity:line.quantity,properties});
  }
 }
 let {updates,missing}=giftReconciliation(cart,fees);
 if(Object.keys(updates).length)cart=await request('cart/update.js',{updates});
 if(missing.length){
  const items=missing.map(line=>({id:fees[/matcha|everest/i.test(line.handle)?3900:1900],quantity:giftUnits(line).length,properties:{
   _cc_gift_role:'fee',_cc_gift_group:line.properties._cc_gift_group,
   'Produkt do zapakowania':line.product_title,
   'Wariant':line.variant_title==='Default Title'?'Produkt':line.variant_title,
   'Wybrane sztuki':giftUnits(line).join(', '),
   ...(line.properties.Tekst?{'Grawer':line.properties.Tekst}:{}),
   ...(line.properties._cc_engraving_group?{'Projekt graweru':line.properties._cc_engraving_group}:{})
  }}));
  await request('cart/add.js',{items});
  cart=await request('cart.js');
 }
 return cart;
}
window.ccGiftReconcile=async()=>{if(busy)throw Error('Trwa zapisywanie pakowania. Poczekaj chwilę.');busy=true;try{return await reconcile();}finally{busy=false;}};
document.addEventListener('click',async event=>{
 const button=event.target.closest('[data-gift-save]');if(!button)return;
 event.preventDefault();if(busy)return;busy=true;button.disabled=true;
 const picker=button.closest('[data-gift-key]'),status=picker.querySelector('[data-gift-status]');
 status.textContent='Zapisywanie…';
 try{
  const cart=await request('cart.js'),line=cart.items.find(item=>item.key===picker.dataset.giftKey);
  if(!line)throw Error('Koszyk się zmienił. Odśwież stronę i ponów wybór.');
  const units=Array.from(picker.querySelectorAll('input:checked'),el=>Number(el.value));
  const group=line.properties?._cc_gift_group||crypto.randomUUID();
  await request('cart/change.js',{id:line.key,quantity:line.quantity,properties:giftProperties(line,units,group)});
  const oldFees=cart.items.filter(item=>item.properties?._cc_gift_role==='fee'&&item.properties._cc_gift_group===group);
  if(oldFees.length)await request('cart/update.js',{updates:Object.fromEntries(oldFees.map(item=>[item.key,0]))});
  await reconcile();location.assign(base+'cart');
 }catch(error){status.textContent=error.message;}finally{busy=false;button.disabled=false;}
});
function decorate(){for(const picker of document.querySelectorAll('.cc-gift-picker')){const details=picker.closest('.cart-item__details')||picker.closest('.cart-item')?.querySelector('.cart-drawer-item__right');if(details&&details.lastElementChild!==picker)details.append(picker);}for(const marker of document.querySelectorAll('.cc-gift-fee-marker'))marker.closest('.cart-item')?.classList.add('cc-gift-fee');}
new MutationObserver(decorate).observe(document.body,{childList:true,subtree:true});decorate();

async function changeWrappedQuantity(picker,quantity){
 if(busy)return;busy=true;
 try{
  await request('cart/change.js',{id:picker.dataset.giftKey,quantity});
  await reconcile();location.assign(base+'cart');
 }catch(error){picker.open=true;picker.querySelector('[data-gift-status]').textContent=error.message;}finally{busy=false;}
}
function wrappedPicker(target){
 const row=target.closest('.cart-item');
 if(row?.querySelector('.cc-cart-personalise[data-group]:not([data-group=""])'))return null;
 return row?.querySelector('[data-gift-selected]:not([data-gift-selected=""])');
}
document.addEventListener('click',event=>{
 const picker=wrappedPicker(event.target);if(!picker)return;
 const remove=event.target.closest('cart-remove-button'),button=event.target.closest('button[name="plus"],button[name="minus"]');
 if(!remove&&!button)return;
 event.preventDefault();event.stopImmediatePropagation();
 const input=picker.closest('.cart-item').querySelector('.quantity__input');
 changeWrappedQuantity(picker,remove?0:Math.max(0,Number(input.value)+(button.name==='plus'?1:-1)));
},true);
document.addEventListener('change',event=>{
 if(!event.target.matches('.quantity__input'))return;
 const picker=wrappedPicker(event.target);if(!picker)return;
 event.preventDefault();event.stopImmediatePropagation();
 changeWrappedQuantity(picker,Math.max(0,Number(event.target.value)||0));
},true);

// Optional finishing-step offer: wrap one further unit, preserving engraving data.
window.ccGiftAdd=async key=>{
 if(busy)throw Error('Trwa zapisywanie pakowania. Poczekaj chwilę.');
 busy=true;
 try{
  const cart=await request('cart.js'),line=cart.items.find(item=>item.key===key);
  if(!line)throw Error('Koszyk się zmienił. Odśwież i spróbuj ponownie.');
  const units=giftUnits(line),next=Array.from({length:line.quantity},(_,i)=>i+1).find(n=>!units.includes(n));
  if(!next)throw Error('Wszystkie sztuki tego produktu są już zapakowane.');
  await request('cart/change.js',{id:key,quantity:line.quantity,properties:giftProperties(line,[...units,next],line.properties?._cc_gift_group||crypto.randomUUID())});
  return await reconcile();
 }finally{busy=false;}
};
